/* eslint-disable */
import jQuery from 'jquery'
import Application from '../application'
export default {
    install(Vue, options) {
        Vue.mixin({
            beforeCreate() {
                var instance = this
                jQuery.ajaxSetup({
                    xhrFields: {
                        withCredentials: true
                    },
                    statusCode: {
                        401(xhr) {
                            instance.$router.replace(Application.onLoggedOutRedirectTo)
                        },
                        403(xhr) {
                            instance.$root.$snackbar('No tienes suficientes credenciales para acceder al recurso.', { color: 'error' })
                        },
                        404(xhr) {
                            instance.$root.$snackbar('El recurso al que estás intentando acceder no pudo ser encontrado.', { color: 'error' })
                        }
                    }
                })
                this.$ajax = {
                    get: function (url, params) {
                        return new Promise(function (resolve, reject) {
                            jQuery.ajax({
                                url: Application.BaseUrl + url,
                                type: 'get',
                                data: (typeof params === 'undefined') ? {} : params,
                                success: function (data, status, jqxhr) {
                                    resolve({ data, status, jqxhr })
                                },
                                error: function (jqxhr, status, error) {
                                    reject({ jqxhr, status, error })
                                }
                            })
                        })
                    },
                    post: function (url, params) {
                        return new Promise(function (resolve, reject) {
                            jQuery.ajax({
                                url: Application.BaseUrl + url,
                                type: 'post',
                                data: (typeof params === 'undefined') ? {} : params,
                                success: function (data, status, jqxhr) {
                                    resolve({ data, status, jqxhr })
                                },
                                error: function (jqxhr, status, error) {
                                    reject({ jqxhr, status, error })
                                }
                            })
                        })
                    },
                    delete: function (url, params) {
                        return new Promise(function (resolve, reject) {
                            jQuery.ajax({
                                url: Application.BaseUrl + url,
                                type: 'delete',
                                data: (typeof params === 'undefined') ? {} : params,
                                success: function (data, status, jqxhr) {
                                    resolve({ data, status, jqxhr })
                                },
                                error: function (jqxhr, status, error) {
                                    reject({ jqxhr, status, error })
                                }
                            })
                        })
                    },
                    put: function (url, params) {
                        return new Promise(function (resolve, reject) {
                            jQuery.ajax({
                                url: Application.BaseUrl + url,
                                type: 'put',
                                data: (typeof params === 'undefined') ? {} : params,
                                success: function (data, status, jqxhr) {
                                    resolve({ data, status, jqxhr })
                                },
                                error: function (jqxhr, status, error) {
                                    reject({ jqxhr, status, error })
                                }
                            })
                        })
                    },
                    getJSON: function (url, params) {
                        return new Promise(function (resolve, reject) {
                            jQuery.getJSON(Application.BaseUrl + url, (typeof params === 'undefined') ? {} : params, function (data, status, jqxhr) {
                                resolve({ data, status, jqxhr })
                            }).fail(function (jqxhr, status, error) {
                                reject({ jqxhr, status, error })
                            })
                        })
                    },
                    getScriptandExecute: function (url) {
                        return new Promise(function (resolve, reject) {
                            jQuery.getScript(Application.BaseUrl + url, function (data, status, jqxhr) {
                                resolve({ data, status, jqxhr })
                            }).fail(function (jqxhr, status, error) {
                                reject({ jqxhr, status, error })
                            })
                        })
                    },
                    error: function (params) {
                        instance.$Progress.fail()
                        return new Promise(function (resolve, reject) {
                            params.error = (typeof params.error !== 'undefined') ? 'Tipo de Error: ' + params.error : ''
                            instance.$root.$snackbar('¡Ocurrió un error al procesar la solicitud! ' + params.error, { color: 'error' })
                            resolve()
                        })
                    }
                }
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/scripts/VueAjaxSetup.js